// extracted by mini-css-extract-plugin
module.exports = {"CustomerInformationWrapper":"CustomerInformation_CustomerInformationWrapper__5N90G"};